import React from "react";

import {
  Card,
  CardLabel,
  HelperText,
} from "../../../../components/MobileForm/styles";
import {
  FormInput,
  FormMoneyInput,
  InputDate,
} from "../../../../components/Input";
import { localToday } from "../../../../utils";
import { CASHBACK_CORRECTION_AMOUNT_HELPER } from "../constants";
import { cashbackCappedAmountRules } from "../tradeValidation";
import { MobileCashbackFundingFields } from "../MobileCashbackFundingFields";
import { MobileChargeField } from "../MobileChargeField";
import { MobileInterestDirectionField } from "../MobileInterestDirectionField";
import { MobileNoteField } from "../MobileNoteField";
import { MobileTradeCorrectionFormProps } from "./types";
import { ContextCard, ContextHint, ContextLine } from "./styles";

export const MobileTradeCorrectionForm: React.FC<
  MobileTradeCorrectionFormProps
> = ({
  control,
  copy,
  contextLine,
  showsQuantity,
  showsCharge,
  directionGroupLabel,
  direction,
  directionError,
  onDirectionChange,
  charge,
  taxedIncome,
  minDate,
  dateRules,
  quantityRules,
  cashback,
  isSubmitting,
}) => {
  return (
    <>
      <ContextCard>
        <ContextLine>{contextLine}</ContextLine>
        <ContextHint>{copy.contextHint}</ContextHint>
      </ContextCard>

      {directionGroupLabel && (
        <Card>
          <MobileInterestDirectionField
            value={direction}
            groupLabel={directionGroupLabel}
            isSubmitting={isSubmitting}
            error={directionError}
            onChange={onDirectionChange}
          />
        </Card>
      )}

      {showsQuantity && (
        <Card>
          <CardLabel htmlFor="mobile-trade-correction-quantity">
            Quantity *
          </CardLabel>
          <FormInput
            id="mobile-trade-correction-quantity"
            required
            name="quantity"
            control={control}
            rules={quantityRules}
            handleClear={false}
            disabled={isSubmitting}
            placeholder="e.g. 12.5"
          />
          <HelperText>Units traded, up to 6 decimal places.</HelperText>
        </Card>
      )}

      <Card>
        <CardLabel htmlFor="mobile-trade-correction-amount">Amount *</CardLabel>
        <FormMoneyInput
          id="mobile-trade-correction-amount"
          required
          name="amountEur"
          control={control}
          rules={cashbackCappedAmountRules}
          disabled={isSubmitting}
          placeholder="0.00"
          variant="title"
        />
        <HelperText>{copy.amountHelper}</HelperText>
      </Card>

      {showsCharge && (
        <Card>
          <MobileChargeField
            id="mobile-trade-correction-fee"
            control={control}
            charge={charge}
            helper={copy.chargeHelper}
            isSubmitting={isSubmitting}
            taxedIncome={taxedIncome}
          />
        </Card>
      )}

      {cashback.isShown && (
        <MobileCashbackFundingFields
          idPrefix="mobile-trade-correction"
          control={control}
          sourceOptions={cashback.sourceOptions}
          amountHelper={CASHBACK_CORRECTION_AMOUNT_HELPER}
          isSubmitting={isSubmitting}
        />
      )}

      <Card>
        <CardLabel htmlFor="mobile-trade-correction-date">
          Trade date *
        </CardLabel>
        <InputDate
          id="mobile-trade-correction-date"
          name="date"
          control={control}
          rules={dateRules}
          disabled={isSubmitting}
          minDate={minDate}
          maxDate={localToday()}
          placeholder="YYYY/MM/DD"
        />
        <HelperText>Must be on or after the account's start date.</HelperText>
      </Card>

      <Card>
        <MobileNoteField
          id="mobile-trade-correction-note"
          control={control}
          isSubmitting={isSubmitting}
        />
      </Card>
    </>
  );
};
